import './App.css';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './Components/Pages/Dashboard';
import AboutUs from './Components/Pages/AboutUs';
import Services from './Components/Pages/Services';
import Projects from './Components/Pages/Projects';
import Jobs from './Components/Pages/Jobs';
import ContactUs from './Components/Pages/ContactUs';

import HRSolutions from './Components/Pages/HRSolutions';
import ResearchStudies from './Components/Pages/ResearchStudies';
import HealthAndHospital from './Components/Pages/HealthAndHospital';
import NGOConsultancy from './Components/Pages/NGOConsultancy';
import TechnicalAssistance from './Components/Pages/TechnicalAssistance';
import SupplyChain from './Components/Pages/SupplyChain';
import CSRSolutions from './Components/Pages/CSRSolutions';
import SBCCServices from './Components/Pages/SBCCServices';
import Documentation from './Components/Pages/Documentation';
import FinancialCompliance from './Components/Pages/FinancialCompliance';
import EducationTraining from './Components/Pages/EducationTraining';

function App() {
  return (
    <Router>
    <div className="App">
    <ScrollToTop />
    <Navbar/>
    <Routes>
            <Route exact path="/about" element={<AboutUs/>} />
            <Route exact path="/services" element={<Services/>} />
            <Route exact path="/projects" element={<Projects/>} />
            <Route exact path="/jobs" element={<Jobs/>} />
            <Route exact path="/contactus" element={<ContactUs/>} />
            <Route exact path="/hr-solutions" element={<HRSolutions/>} />
            <Route exact path="/research-studies" element={<ResearchStudies/>} />
            <Route exact path="/health-and-hospital" element={<HealthAndHospital/>} />
            <Route exact path="/ngo-consultancy" element={<NGOConsultancy/>} />
            <Route exact path="/technical-assistance" element={<TechnicalAssistance/>} />
            <Route exact path="/supply-chain" element={<SupplyChain/>} />
            <Route exact path="/csr-solutions" element={<CSRSolutions/>} />
            <Route exact path="/sbcc-services" element={<SBCCServices/>} />
            <Route exact path="/documentation" element={<Documentation/>} />
            <Route exact path="/financial-compliance" element={<FinancialCompliance/>} />
            <Route exact path="/education-training" element={<EducationTraining/>} />
            
            {/* <Route exact path="/payment" element={<Elements stripe={promise}><Payment /></Elements>} /> */}
            {/* for rendering depending on a promise */}
            <Route path="/" element={<Dashboard />} /> 
             {/* Default root should be at bottom */}
    </Routes>
    
    
    <Footer/>
    </div>
    </Router>
  );
}

export default App;
